import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ActionCableSubscriptionStatus } from '@repo/utils';

export interface ChatWidgetState {
  subscriptionStatus: ActionCableSubscriptionStatus;
  unreadMessagesCount: number | undefined;
}

const initialState: ChatWidgetState = {
  subscriptionStatus: ActionCableSubscriptionStatus.UNINITIALIZED,
  unreadMessagesCount: undefined,
};

export const chatWidgetSlice = createSlice({
  name: 'chatWidget',
  initialState,
  reducers: {
    setSubscriptionStatus: (state, action: PayloadAction<ActionCableSubscriptionStatus>) => {
      state.subscriptionStatus = action.payload;
    },
    setUnreadMessagesCount: (state, action: PayloadAction<number | undefined>) => {
      state.unreadMessagesCount = action.payload;
    },
  },
});

export const {
  setSubscriptionStatus,
  setUnreadMessagesCount,
} = chatWidgetSlice.actions;

export default chatWidgetSlice.reducer;
